import { render } from "./Sleepwalking.vue?vue&type=template&id=aec2423c&bindings={}"
import script from "./Sleepwalking.vue?vue&type=script&lang=ts"
export * from "./Sleepwalking.vue?vue&type=script&lang=ts"

import "./Sleepwalking.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script